import React, {FC} from 'react';
import styled from 'styled-components';

import {DropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {center, ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {BoxedIcon} from '../../../components/common/boxedIcon';

export const SettingsSearchDropdownItem = styled(DropdownItem)`
  padding: 6px 0 7px 0;
  ${ellipsis()};
  flex-shrink: 0;
`;

export const SettingsSearchDropdownItemLeftIcon = styled.div`
  grid-area: left-icon;
  margin-right: 12px;
  align-self: center;
  min-width: 32px;
  ${center()};
`;

export const SettingsSearchDropdownContent = styled.div`
  grid-area: content;
  ${ellipsis()};
  max-width: 100%;
`;

export const SettingsSearchDropdownTitle = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.medium};
  color: ${(p) => p.theme.greys.shade80};

  margin-top: -1px;

  ${ellipsis()};
  line-height: normal;
`;

export const SettingsSearchDropdownTitleAccessory = styled.div`
  margin-left: 5px;
  margin-top: 1px;
  vertical-align: bottom;
  display: inline-block;
`;

export const SettingsSearchDropdownSubtitle = styled.div`
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.normal};
  color: ${(p) => p.theme.greys.shade70};
  ${ellipsis()};
  line-height: normal;
  margin-top: 4px;
`;

export const StyledLockIconWrapper = styled(SettingsSearchDropdownTitleAccessory)`
  vertical-align: initial;
  margin-top: 0;
  transform: translateY(1px);
`;

export const SettingsSearchDropdownGenericIcon: FC<{name: IconName}> = (props) => {
  const theme = useUserTheme();

  return (
    <BoxedIcon
      name={props.name}
      color={theme.greys.shade70}
      backgroundColor={theme.greys.shade30}
      size={VisualSizesEnum.SMALL}
    />
  );
};
